import { MessageTextLockIcon } from './MessageTextLockIcon';

/**
 * author: Simran
 * id 362401F1-947F-45FD-8047-F515CB2F7C44
 * name message-text-lock
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-text-lock.svg
 * tags
 * - Lock 
 */
export const MessageTextSecureIcon = MessageTextLockIcon;
export default MessageTextSecureIcon